export default function deprecated(msg) {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(msg);
  }
}



// WEBPACK FOOTER //
// ./javascripts/components/deprecated.js